import { Outlet, useNavigate } from "react-router-dom";

export default function AppLayout() {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("user");
    sessionStorage.removeItem("user");
    navigate("/LoginPage", { replace: true });
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-100 font-sans">
      <header className="bg-white shadow px-6 py-3 flex justify-between items-center">
        <h1 className="text-lg font-semibold text-gray-700">Sppipe-Jctrack</h1>
        <button
          onClick={logout}
          className="px-3 py-1 bg-red-600 hover:bg-red-700 text-white text-sm rounded-md shadow"
        >
          Logout
        </button>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}